// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwPodElement-wrap","label":"CwPodElement-label","required":"CwPodElement-required","labelinvalid":"CwPodElement-labelinvalid","labelblue":"CwPodElement-labelblue"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpod/CwPodElement.scss
// module id = 379
// module chunks = 0